import React, { useState } from 'react'
import { Auth } from 'aws-amplify'
import { Menu, Spin } from 'antd'
import { PoweroffOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router'

const propTypes = {}

const defaultProps = {}

const UserMenu = () => {
  const [loadingLogOut, setLoadingLogOut] = useState(false)

  const history = useHistory()

  const logOut = () => {
    setLoadingLogOut(true)
    Auth.signOut({ global: true }).then(() => {
      setLoadingLogOut(false)
      history.push('/login')
    }).catch(err => {
      setLoadingLogOut(false)
      history.push('/login')
    })
  }
  return (
    <Menu style={{ boxShadow: '10px 10px 44px 5px rgba(0,0,0,0.2)' }}>
      <Menu.Item onClick={logOut}>
        {loadingLogOut ? (
          <div style={{ display: 'flex', justifyContent:'center', marginTop: '12%' }}>
          <Spin />
          </div>
        ) : (
          <>
            <PoweroffOutlined /> Cerrar Sesión
          </>
        )}
      </Menu.Item>
    </Menu>
  )
}

UserMenu.propTypes = propTypes
UserMenu.defaultProps = defaultProps

export default UserMenu
